import React from 'react'
import hairSpaTreatmentImg from "./../../../../../Images/Blog/Hair_Spa_Treatments/Banner.png";

const HairSpaTreatmentImg = () => {
  return (
    <div className="blogImg-content">
    <img
      src={hairSpaTreatmentImg}
      alt="hairSpaTreatmentImg"
      loading="lazy"
    />
  </div>
  )
}

export default HairSpaTreatmentImg
